export enum ReportPeriod {
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
  ALL_TIME = "ALL_TIME"
}
